// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> aion-management-comfy -> shadow-hill
// Generated: 2026-10-22T20:05:12.490Z
// Counts: 5 design, 68 content, 58 slot group, 3 collection binding, 9 section, 5 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Accessibility",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Amenities",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Apply Now",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Contact Us",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Floor Plans",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Gallery",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 48px;\">Welcome To</span></h1><h1><span style=\"font-size: 48px;\"><span data-type=\"field-token\" data-field=\"property_name\"></span></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Neighborhood",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>The heart of a growing community</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Pet Policy",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Privacy Policy",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apartments and Townhomes in Sharonville, OH</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Resident Portal",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Schedule a Tour",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "fee-information-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Transparent pricing for <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "fee-information-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Fee Information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Spaciously Designed Apartments For Rent</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/pet-friendly-apartments-beverly-nj::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore apartments in your area</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/pet-friendly-apartments-beverly-nj::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Hyperlocal Page Title</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore the community layout</h2><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Your pet belongs <em>here, too.</em></h3><h3></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Shadow Hill Apartments and Townhomes in Sharonville, OH, offers a serene, tree-lined community with easy access to I‑275 and Route 42. Residents enjoy amenities like two swimming pools, a clubhouse, and sand volleyball.</p><p>Enjoy comfort and convenience at our Sharonville apartments, featuring air conditioning, spacious closets, and efficient appliances, with on-site management and 24-hour emergency maintenance to make apartment living effortless.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.heading": {
    "overrideType": "VALUE",
    "customValue": "Resident Portal",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents are saying</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-form.talk_blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_scheduletour_blurb"
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Tour the community from anywhere</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Shadow Hill offers residents a beautiful setting to call home. Choose from thoughtfully designed <a href=\"/floor-plans\">1-, 2-, or 3-bedroom apartments or townhomes in Sharonville, OH</a>, complemented by amenities just outside your front door. Enjoy one of two sparkling swimming pools or attend resident social events hosted throughout the community. Nearby, Sharon Woods offers access to a Naturalist Center, golf, hiking trails, boating, and more.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Shadow Hill in Sharonville, OH, our vibrant community offers spacious one, two, and three-bedroom apartments designed for comfort and convenience. Enjoy two refreshing swimming pools, a playground, and a welcoming clubhouse surrounded by beautiful views. Experience prompt maintenance and friendly on-site management. Your new home awaits—lease online today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Shadow Hill in Sharonville, OH, where your ideal living space awaits! Choose from our thoughtfully designed one-, two-, or three-bedroom apartments or townhomes near Cincinnati, tailored to fit your lifestyle. Dive into comfort and style—browse our available apartment homes today and find the perfect layout for your next chapter!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Shadow Hill in Sharonville, OH, imagine waking up to beautiful views and enjoying life with two refreshing swimming pools and a playground. Choose from spacious one to three-bedroom floor plans featuring modern amenities, like fully equipped kitchens and patios or juliette balconies. Picture yourself living here amidst comfort and convenience!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.name": {
    "overrideType": "VALUE",
    "customValue": "Shadow Hill",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Shadow Hill Apartments and Townhomes offer a quiet setting in a prime location <a href=\"https://www.liveshadowhillapartments.com/neighborhood/\">near Cincinnati</a>. Located in Sharonville, our community provides easy access to Route 42, I‑275, I‑75, and I‑71, putting all of Sharonville and the surrounding areas within reach.&nbsp;</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Nestled in Sharonville, Shadow Hill offers unparalleled access to vibrant community spaces, parks, and cultural gems like the National Voice of America Museum. Our <a href=\"/floor-plans\">1-, 2-, and 3-bedroom apartments</a> are just minutes from major highways I‑275, I‑75, and I‑71, as well as Route 42, making Cincinnati, OH, and surrounding areas easily accessible. Enjoy shopping and dining at nearby Kenwood Mall, or explore the natural beauty of Sharon Woods Park, just steps from your front door.&nbsp;</p><p>Come join us and experience comfort, convenience, and community at Shadow Hill.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span> <span>We welcome dogs and cats up to 50 lbs. One-time non‑refundable pet fee: $300 per pet. Monthly pet rent: $30 per pet. Maximum of 2 pets per unit. Breed restrictions apply: American Pitbull Terrier, Bull Terrier, Staffordshire Bull Terrier, Doberman Pinscher, Rottweiler, Chow, Akita, Wolf Hybrid, German Shepherd or any mix thereof are not allowed.</span> </span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.&nbsp;</span></p><p><span>We collect information from visitors on our Web site through online requests including:</span></p><p><span>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.&nbsp;</span></p><p><span>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. n addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.&nbsp;</span></p><p><span>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.&nbsp;</span></p><p><span>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.&nbsp;</span></p><p><span>From time to time, we may send a “cookie” to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer’s hard drive. A cookie can’t read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.&nbsp;</span></p><p><span>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.&nbsp;</span></p><p><span>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.&nbsp;</span></p><p><span>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Shadow Hill in Sharonville, OH, your perfect home awaits with versatile floor plans—including one, two, and three-bedroom options. Seamlessly manage your living experience through our resident portal, where paying rent and scheduling maintenance is just a click away. Elevate your lifestyle today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.app_heading": {
    "overrideType": "VALUE",
    "customValue": "Download the Loft Resident Mobile App",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span> <span>At Shadow Hill in Sharonville, OH, find your ideal retreat with our spacious one, two, and three-bedroom floor plans. Each apartment is designed for comfort and style. Ready to experience the community vibe? Schedule a tour today and see what our residents have to say about their wonderful home!</span> </span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Thank You",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span> <span>Thank you for reaching out to Shadow Hill in Sharonville, OH! We offer a variety of thoughtfully designed floor plans, from cozy one-bedrooms to spacious three-bedrooms, tailored for your lifestyle. A team member will connect with you soon to help you take the next step toward your new home.</span> </span></p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "residentaccess.login_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Access Resident Portal Login"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167057/019d270e-4f80-70ae-926e-64065ccd010d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Interior view of a leasing office with a red couch, chairs, desks, and a view of the pool."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167057/019d026e-d5c0-774b-947e-02c44a17408f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Lobby area with sofas, coffee table, and popcorn machine."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167057/019d026e-8eb0-7389-ae44-a7f799b6e63f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Office reception area with seating and view of the pool."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167057/019d026e-dd2b-767c-a334-25f1fc16050d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with white cabinets and countertops, stainless steel sink, and a dining area visible in the background."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167057/019d270e-3cd5-70c1-aa29-15e12c6cfa4a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a large bed, nightstands, dresser, and a window."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167057/019d270e-444d-734a-ad99-6f77b58bd901.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A neutral-toned bathroom with a bathtub, toilet, and vanity."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167057/019d026f-c47a-7243-b69f-e54d99587661.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment buildings surrounded by mature trees with colorful fall foliage."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167057/019d026e-805f-75fa-bbb6-758837cc8b3a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of brick apartment buildings with large trees providing shade."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167057/019d026e-6d66-7280-a6cb-a598f4c7b817.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment building with manicured landscaping and a parking lot."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167057/019d026e-ae76-709c-ab95-bd058eb52c58.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs, tables, and a grill area."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167057/019d026e-b82f-7192-ab72-8fce99b3075e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Playground with swings and slide next to a fenced-in swimming pool."
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167057/019d026e-7e2f-755b-99dd-f32e35a8ef0c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Volleyball court with sand and net, adjacent to a brick building and surrounded by trees."
      }
    }
  },
  "feesheet.admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Admin Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$100"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.amenity": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "2 Months' Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.custom_required": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Electric Reimbursement"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$4–$6"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Gas"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$14–$21"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.month_to_month": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Month To Month"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.pest": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pest Control"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$5"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_rent_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "25"
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.trash": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Trash Service"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$15"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$54–$82"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[3].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[3].image_media.alt_text"
      }
    }
  },
  "hero.feature_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167057/019d026e-a14a-7445-9b6b-1bb40b8b42ea.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Sparkling swimming pool with lounge chairs and umbrellas on the patio."
      }
    }
  },
  "hero.feature_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167057/019d026e-d5c0-774b-947e-02c44a17408f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Lobby area with sofas, coffee table, and popcorn machine."
      }
    }
  },
  "hero.feature_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167057/019d026f-b920-71cd-b3b0-17451ad87995.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy living room with gray sofa, armchair, and coffee table."
      }
    }
  },
  "hero.feature_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167057/019d026e-dd2b-767c-a334-25f1fc16050d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with white cabinets and countertops, stainless steel sink, and a dining area visible in the background."
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-5b49-703b-a930-dc934ac7f659.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Blue Goose Sports Cafe"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Restaurants"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.7"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Casual sports bar & restaurant offering American comfort food, beer on tap & Sunday brunch."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-86c2-700f-9160-299cf6f5eff8.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Gabe's"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Shopping & Retail"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Discount chain stocking brand-name apparel, shoes & accessories for adults & kids, plus housewares."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-f288-7459-83c0-f7c7ad03ebad.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Sharon Woods"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Recreation area with paved trails, golf, boating, an indoor playground & a village museum."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-6814-71ed-b4e7-de0ba8cd8b70.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "New Krishna Indian Cuisine"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Restaurants"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "0.7"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Modern Indian eatery dishing up classic tandoori dishes, biryani & curry, coupled with beer & wine."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-b6e1-724d-8063-86b4d74292e3.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Heritage Village Museum"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Entertainment"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Living history museum featuring live reenactments of 19th-century daily life in a recreated village."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-e961-775b-9684-8a5723017ada.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Sharonville Community Center"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Health and Wellness"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Fitness gym, pool and exercise track, plus courts for basketball and pickleball."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-68cb-739f-afdd-81b4062ab0d8.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "On The Rocks Bourbon Bar & Restaurant"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Restaurants"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Warm, wood-lined bar and restaurant pouring an ample bourbon selection alongside a full dinner menu."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-c605-721a-8e46-51cc37a0f0fb.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Bogart's"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Entertainment"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "3-story concert hall housing 6 bars & a performance space for local, national & international acts."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-7b4b-73bd-a93b-fba402325a05.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Benihana - Cincinnati"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Restaurants"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.5"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Hibachi chain serving Japanese dishes grilled tableside by theatrical chefs."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-64a6-76ef-83cf-b4a46b6f988e.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Damn Good Bar & Grill"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Restaurants"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Easygoing bar and grill with hearty pub plates, cold drinks, and a laid-back late-night vibe."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-d60c-732d-91df-865cae5aa79c.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Cinemark Oakley Station and XD"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Entertainment"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-8498-71b9-bb69-26ae5f113378.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Blue Ash Chili"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Restaurants"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.2"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Diner-style fixture for double-decker sandwiches & Cincinnati-style chili in multiple combinations."
      }
    }
  },
  "propertyoverview.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/01a06409-b8c2-778a-a92b-4652cee32452.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a queen-size bed, nightstands, and a dresser. A window overlooks trees and buildings."
      }
    }
  },
  "propertyoverview.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/01a06409-d80d-736e-8fff-fe85473cddcc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Clean white kitchen with granite countertops and modern appliances."
      }
    }
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/01a06409-b35e-7514-bbd3-2427b4af2817.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and tables."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "homegallerypreview.photos": {
    "limit": 4,
    "hiddenIds": null,
    "orderedIds": [
      "custom_dc2bff10-f588-47f8-867e-eb68f6d2f53d",
      "custom_b08ec63a-db51-41b5-b24d-fac343b71fe5",
      "custom_868872c0-3d1a-47d8-a71c-900da628e3ec",
      "custom_c4833c1a-21b8-46ac-a02c-237deaedc1ea",
      "custom_fd54ff56-b87f-408a-9475-151fb915bb09",
      "custom_bff8daf1-9b04-4dec-bc1b-e971d5b9507a",
      "custom_af1b05a9-aa7f-4828-86dc-ce1a894447b9",
      "custom_72575e6a-2783-42f1-9282-6462d7279eff",
      "custom_e8591707-6ba7-47cc-b320-3d70ae944d73",
      "custom_85f31b1f-e2b3-4df2-8a72-20c9f3efe7a2",
      "custom_16c4d3f6-0c92-475e-a923-ba4ece0cbc22",
      "custom_739c9d13-9f95-4683-9a0d-a24a7feaa09e",
      "custom_444e2025-a34a-406a-b2e1-17cfd80e7cd6",
      "custom_d9e7671f-7eae-4ccc-961b-9c72c7c5bb1b",
      "custom_bca24074-7524-45a5-b03c-7648bfbc97da",
      "custom_4cea6b47-5353-48ac-95c9-791090a9a46c",
      "custom_d5524cfc-405e-41d7-9a93-6dd2cb3dca06",
      "custom_23726c7f-1204-46b8-9f25-d128c46a8b00",
      "custom_9d80b12a-d9b3-497c-89f6-61c4d98b44cc"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_ced29ced-f89b-4b8a-866a-68a333dd2e57",
      "custom_a3c822c7-21c0-4eb4-92b9-d679864bcca8",
      "custom_5bbda648-0a92-45a3-97cc-1f544cb1c233",
      "custom_56e33518-4570-476d-95b5-389297520e90",
      "custom_69e32342-ebc9-4978-97cb-92e20f440d40",
      "custom_39c94142-f329-41ee-abe2-db814913edfd",
      "custom_8fa248fc-2d8a-492f-a8d0-6448fa5a31bd",
      "custom_4faf9832-e87c-465e-90a9-014451e425ee",
      "custom_270227d9-e8b4-462d-9bd6-4cde1d461a25",
      "custom_c549c62e-96b7-4f9c-acfa-3d3d30c11b3e",
      "custom_706c179d-6145-4f8f-923d-41aafec483ae",
      "custom_d6a27f07-e3be-4b35-9aba-0055bdac862c",
      "custom_829f31ef-41b7-4d92-b71c-d30ee0bdff0b",
      "custom_9ec4bbac-d0c6-4fba-ace8-72492f0daf9b",
      "custom_05be6fa5-dbd4-4020-a520-fcd6de9230fe",
      "custom_b6985cdc-922a-4c31-9321-99c912439cc5",
      "custom_74f0619d-24ca-4b6f-9acd-d9f8d87e68e8",
      "custom_950053e9-db07-4c1c-878e-0e8b4f0abc09",
      "custom_9f4cd844-514d-4edc-a686-6e8d66e76b5f",
      "custom_edb59427-af1a-4a48-9670-2d43ad281598",
      "custom_eadc5ae0-240a-4c35-ad74-77f8aa23ae5c",
      "custom_889f3b19-2658-4cd8-8f5e-9fbdf29e1dc4",
      "custom_36a18db6-35d9-46f9-bc14-ebf4a7f36414",
      "custom_0d50cc74-f154-4284-a09b-9aaf0e7b51c6"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "photogallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_af1b05a9-aa7f-4828-86dc-ce1a894447b9"
    ],
    "orderedIds": [
      "custom_d9e7671f-7eae-4ccc-961b-9c72c7c5bb1b",
      "custom_4cea6b47-5353-48ac-95c9-791090a9a46c",
      "custom_b08ec63a-db51-41b5-b24d-fac343b71fe5",
      "custom_bff8daf1-9b04-4dec-bc1b-e971d5b9507a",
      "custom_c4833c1a-21b8-46ac-a02c-237deaedc1ea",
      "custom_bca24074-7524-45a5-b03c-7648bfbc97da",
      "custom_d5524cfc-405e-41d7-9a93-6dd2cb3dca06",
      "custom_23726c7f-1204-46b8-9f25-d128c46a8b00",
      "custom_739c9d13-9f95-4683-9a0d-a24a7feaa09e",
      "custom_16c4d3f6-0c92-475e-a923-ba4ece0cbc22",
      "custom_9d80b12a-d9b3-497c-89f6-61c4d98b44cc",
      "custom_868872c0-3d1a-47d8-a71c-900da628e3ec",
      "custom_72575e6a-2783-42f1-9282-6462d7279eff",
      "custom_e8591707-6ba7-47cc-b320-3d70ae944d73",
      "custom_85f31b1f-e2b3-4df2-8a72-20c9f3efe7a2",
      "custom_444e2025-a34a-406a-b2e1-17cfd80e7cd6",
      "custom_fd54ff56-b87f-408a-9475-151fb915bb09",
      "custom_dc2bff10-f588-47f8-867e-eb68f6d2f53d",
      "custom_af1b05a9-aa7f-4828-86dc-ce1a894447b9"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_template:hyperlocal::_section.block:apartment-sync": {
    "properties": {
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "apartmentsyncsection.block": {
    "properties": {
      "paddingBottom": "30px"
    }
  },
  "hero.name": {
    "properties": {
      "paddingBottom": "50px"
    }
  },
  "propertyoverview.blurb": {
    "properties": {
      "fontWeight": "300"
    }
  },
  "residentaccess.app_heading": {
    "properties": {
      "fontWeight": "700"
    }
  }
};
